import { Fraga } from "@/types/riskbedomning";

export const driftUnderhallFragor: Fraga[] = [
  {
    id: "drift-atkomst-fallskydd-sammansatt",
    text: "Riskerar drift- och underhållsarbete att utföras utan säker åtkomst eller tillräckligt fallskydd?",
    kategori: "Drift & underhåll",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar obehöriga att få tillträde till driftutrymmen på grund av bristande tillträdeshantering?",
      "Kan brist på utrymme, lyfthjälpmedel eller planering göra att tunga komponenter inte kan bytas ut utan risk för skador?",
      "Riskerar servicepunkter att vara placerade så att säkert arbete inte kan utföras?",
      "Riskerar permanenta fallskydd att saknas eller vara bristfälligt installerade?",
      "Kan brist på rutiner eller otydligt ansvar för kontroll och underhåll av fallskyddsutrustning öka risken för olyckor?",
      "Riskerar tak och höga positioner att sakna fasta förankringspunkter för säkert arbete?"
    ],
    afsReferences: ["AFS 2023:9"]
  },
  {
    id: "drift-ergonomi-belysning", 
    text: "Riskerar underhållsarbete att utföras med bristande ergonomi och otillräcklig belysning?",
    kategori: "Drift & underhåll",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar viktiga utrymmen att sakna nödbelysning vid strömavbrott eller kris?",
      "Riskerar kritiska underhållsområden att sakna tillräcklig permanent belysning?",
      "Kan bristande elförsörjning eller underhåll medföra att belysningen slocknar i nödsituationer?"
    ],
    afsReferences: ["AFS 2023:12"]
  },
  {
    id: "drift-kemikalier-ventilation",
    text: "Riskerar kemikaliehantering eller ventilation i driftmiljön att vara otillräcklig för att skydda personalen?",
    kategori: "Drift & underhåll",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar driftpersonal att hantera kemikalier utan rätt utbildning eller skyddsutrustning?",
      "Riskerar driftpersonal att sakna enkel tillgång till aktuella säkerhetsdatablad för kemikalier?",
      "Riskerar hantering av kemikaliespill att ske utan fastställda rutiner?",
      "Kan brister i utformning eller märkning av kemikalieförvaring leda till olyckor, spill eller förväxlingar?",
      "Riskerar ventilationen att sakna rutiner för rengöring och kontroll av luftkvalitet enligt krav?"
    ],
    afsReferences: ["AFS 2023:10"]
  },
  {
    id: "drift-buller-utrymning",
    text: "Kan otillräckliga åtgärder mot buller och vibrationer, eller brister i utrymningsvägar, skapa risk för ohälsa eller olyckor i driftmiljön?",
    kategori: "Drift & underhåll",
    fas: "byggskede",
    followUpQuestions: [
      "Kan brist på hörselskydd eller otydliga rutiner för användning leda till att personal exponeras för skadliga ljudnivåer?",
      "Kan brist på tydlig markering eller fri tillgång till nödutgångar i drift- och underhållsutrymmen försvåra en säker utrymning vid brand eller nödläge?",
      "Finns det risk att personalen inte är utbildad i utrymningsrutiner och att regelbundna övningar saknas?",
      "Kan brist på fungerande nödlarm eller kommunikationssystem leda till att personal inte varnas i tid vid brand, olycka eller annan fara?",
      "Kan brist på aktuella eller synligt placerade utrymningsplaner försvåra en snabb och säker evakuering vid brand eller annan nödsituation?",
      "Kan bristande ordning eller tillfälliga hinder göra att utrymningsvägar blockeras och försvårar säker evakuering vid nödläge?"
    ],
    afsReferences: ["AFS 2023:10"]
  },
  {
    id: "drift-underhall-arbetsmiljo",
    text: "Kan bristande rutiner för arbetsmiljöarbete och riskbedömning inom drift och underhåll leda till att faror inte upptäcks eller åtgärdas i tid?",
    kategori: "Drift & underhåll",
    fas: "byggskede", 
    followUpQuestions: [
      "Riskerar driftmiljön att sakna fungerande rutiner för rapportering och uppföljning av olyckor och tillbud?",
      "Finns det risk att det inte är tydligt vem som är ansvarig för arbetsmiljön i olika driftutrymmen?",
      "Riskerar riskbedömningar att inte revideras vid förändringar i system eller utrustning?",
      "Finns risk för att driftunderhållsarbeten utförs utan kravuppfyllelse eller säkra rutiner?",
      "Riskerar arbete från stegar eller arbetsbockar att utföras utan säkrare alternativ?"
    ],
    afsReferences: ["AFS 2023:1"]
  }
];